module.exports = __webpack_public_path__ + "fonts/NeueHaasGroteskDisplay-55Roman-Web.f2aa19b.woff2";